$(document).ready(function() {

  var btn = $(".drpdown-1");
	var txt = $(".cstm-benefits");

	btn.click(function() {
		txt.addClass("active");
        txt2.removeClass("active");
        txt3.removeClass("active");
        btn2.removeClass("active-point");
        btn3.removeClass("active-point");
        btn.addClass("active-point");
	});

  var btn2 = $(".drpdown-2");
	var txt2 = $(".cstm-ingredi");

	btn2.click(function() {
		txt2.addClass("active");
        txt.removeClass("active");
        txt3.removeClass("active");
        btn3.removeClass("active-point");
        btn.removeClass("active-point");
        btn2.addClass("active-point");
	});

  var btn3 = $(".drpdown-3");
	var txt3 = $(".cstm-how");

	btn3.click(function() {
		txt3.addClass("active");
        txt.removeClass("active");
        txt2.removeClass("active");
        btn2.removeClass("active-point");
        btn.removeClass("active-point");
        btn3.addClass("active-point");
	});




  

  if(window.innerWidth < 500) {

    $('.how-to-dirtea-card-row').slick({
      dots: false,
      arrows: false,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 4000,
      speed: 300,
      spaceBetween: 30, 
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
    
  }

    if(window.innerWidth < 500) {

    $('.custom_main_inner_rt').slick({
      dots: false,
      arrows: true,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 4000,
      speed: 300,
      spaceBetween: 30, 
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
    
  }


  
  if(window.innerWidth > 500) {

    $('.inner-section-slider').slick({
      dots: false,
      arrows: false,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 2000,
      speed: 300,
      spaceBetween: 30, 
      adaptiveHeight: true,
      slidesToShow: 3,
      slidesToScroll: 1
    });
    
  } else {

    $('.inner-section-slider').slick({
      dots: false,
      arrows: false,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 2000,
      speed: 300,
      spaceBetween: 30, 
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
    
  }
  
  
$('.cstm_cart_recommendation_product_img_wrapper').slick({
  dots: true,
  arrows: false,
  autoplay: true,
  infinite: true,
  autoplaySpeed: 2000,
  speed: 300,
  slidesToShow: 1.5,
  adaptiveHeight: true, 
  responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
});
  

  if(window.innerWidth > 500) {

    $('.collection-slider .product-list').slick({
      dots: false,
      autoplay: false,
      infinite: true,
      autoplaySpeed: 2000,
      speed: 300,
      spaceBetween: 20, 
      adaptiveHeight: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: $('.collection-slider a.next'),
      prevArrow: $('.collection-slider a.prev')
    });
    
  } else {

      $('.collection-slider .product-list').slick({
        dots: false,
        autoplay: false,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 300,
        spaceBetween: 20, 
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: $('.collection-slider a.next'),
        prevArrow: $('.collection-slider a.prev')
      });
    
  }






  


  
  

  $(".accordion-header").click(function() {
  $(this).toggleClass("active");
  $(this).next(".accordion-body").slideToggle();
});
  
$('.testimonial-slider').slick({
  dots: true,
  autoplay: true,
  infinite: true,
  autoplaySpeed: 5000,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
  nextArrow: $('.swiper-button-next')
});

  if(window.innerWidth > 500) {

    $('.cstm_video_slider_wrapper').slick({
      dots: false,
      autoplay: false,
      infinite: true,
      autoplaySpeed: 2000,
      speed: 300,
      spaceBetween: 30, 
      adaptiveHeight: true,
      slidesToShow: 5,
      slidesToScroll: 1
    });
    
  } else {

    $('.cstm_video_slider_wrapper').slick({
      dots: false,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 2000,
      speed: 300,
      spaceBetween: 30, 
      adaptiveHeight: true,
      slidesToShow: 2,
      slidesToScroll: 1
    });
    
  }
  
  
  
// var videoSlider = $('.cstm_video_slider');

  $('.cstm_video_slider').slick({
  dots: true,
  vertical: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});


if(window.innerWidth > 500) {
      $('.product-slider').slick({
      dots: false,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 2000,
      speed: 300,
      spaceBetween: 30, 
      adaptiveHeight: true,
      slidesToShow: 4,
      slidesToScroll: 1
    });
  
    }else {
      $('.product-slider').slick({
      dots: false,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 2000,
      speed: 300,
      spaceBetween: 0, 
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  
}

    $('.collection-slider-row .product_main_Inner').slick({
      dots: false,
      arrows: true,    
      infinite: true,
      spaceBetween: 0, 
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1
          
    });
  
  
  
  $('.ctM_sldr').click(function() {
    var indexSlider = $(this).attr('data-index');
    console.log(indexSlider);
    $('.cstm_video_popup').addClass('popup_active');
     $('.close-button-slider').addClass('actiev-btn');
      $('.cstm_video_slider').slick('slickGoTo', indexSlider);
  });

  $('.ctM_sldr').click(function(e) {

  e.preventDefault();
  $('.ctM_sldr').click();  
    
  });


 $('.close-button-slider').click(function() {
   
    $('.cstm_video_popup').removeClass('popup_active');
     $('.close-button-slider').removeClass('actiev-btn');

   var popupVideos = $('.cstm_video_wraper_slide > .video-element');

   for (let i = 0; i < popupVideos.length; i++) {
      popupVideos[i].pause();
       console.log(popupVideos);
    }
   
  });
  
  $('.swiper-slide .video_button').click(function() {

    $('.cstm_video_popup').addClass('popup_active');
     $('.close-button-slider').addClass('actiev-btn');
  });
 $('.close-button-slider').click(function() {

    $('.cstm_video_popup').removeClass('popup_active');
     $('.close-button-slider').removeClass('actiev-btn');
  });

  //  $('.question-answer').click(function() {
  //   $('.question').removeClass('active_faq');
  //   $('.question').toggleClass('active_faq');
  // });


      const questions = document.querySelectorAll('.question');
    questions.forEach((question) => {
      question.addEventListener('click', function () {
        const answer = this.nextElementSibling;
        question.classList.toggle("active_faq");
        const arrow = this.querySelector('.arrow');
        answer.style.display = answer.style.display === 'block' ? 'none' : 'block';
        arrow.style.transform = arrow.style.transform === 'rotate(180deg)' ? 'rotate(0deg)' : 'rotate(180deg)';
      });
    });


  // Product images videoSlider
if(window.innerWidth > 500) {

    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      adaptiveHeight: true,
      asNavFor: '.slider-nav'
    });

    $('.slider-nav').slick({
      slidesToShow: 3.26,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      centerMode: true,
      focusOnSelect: true
    });
} else{

      $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      adaptiveHeight: true,
      asNavFor: '.slider-nav'
    });

    $('.slider-nav').slick({
      slidesToShow: 3.54,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      centerMode: true,
      focusOnSelect: true
    });
  
}

  // nutration info

 $('.cstm_info_point').click(function() {

    $('.custm_popup_nutration').addClass('ntv_active');
   
  });

  $('.cstm_info_point').click(function(e) {

  e.preventDefault(); 
    
  });
  
  $('.cross_main_div img').click(function() {

    $('.custm_popup_nutration').removeClass('ntv_active');
  });

    $('.notabutton.mobile-nav-toggle').click(function() {

    $('.ctm_mbl_nav').addClass('active-mbl-nav');
  });

      $('.cross_main_div img').click(function() {

    $('.ctm_mbl_nav').removeClass('active-mbl-nav');
  });



  // if($('body').hasClass('template-product')) {

  //     // document.querySelector('.appstle_subscription_wrapper .appstle_subscription_wrapper_option input').click();

  //   // document.querySelector('.appstle_include_dropdown input').click();

  //   // document.querySelector('.appstle_subscribe_option .appstle_select').value = 3574563122;
    
  // }

        $('.ctm_filter_first').click(function() {

          $('.product-block.detail-mode-permanent').addClass('active_filter_first');
          $('.product-block.detail-mode-permanent').removeClass('active_filter_scnd');

          // Get a reference to the Slick Slider element
          var slider = $('.collection-slider-row .product_main_Inner').slick('refresh');
          
  });

          $('.ctm_filter_scnd').click(function() {

        $('.product-block.detail-mode-permanent').addClass('active_filter_scnd');
        $('.product-block.detail-mode-permanent').removeClass('active_filter_first');

        // Get a reference to the Slick Slider element
        var slider = $('.collection-slider-row .product_main_Inner').slick('refresh');
            
  });


  // subinfo

   $('.shipping_main_inner_3').click(function() {

    $('.sb-pop-main').addClass('ntv_active');
   
  });

  $('.shipping_main_inner_3').click(function(e) {

  e.preventDefault(); 
    
  });
  
  $('.cross_main_div img').click(function() {

    $('.sb-pop-main').removeClass('ntv_active');
  });



  const quantityInput = document.getElementById("quantity");
  const plusButton = document.getElementById("plus");
  const minusButton = document.getElementById("minus");

  plusButton.addEventListener("click", (e) => {
    e.preventDefault();
    let value = parseInt(quantityInput.value);
    quantityInput.value = value + 1;
    return false;
  });

  minusButton.addEventListener("click", (e) => {
    e.preventDefault();
    let value = parseInt(quantityInput.value);
    quantityInput.value = value - 1;
  });


  if($('body').hasClass('template-product')) {

    $('.cstm_submit_form').click(function (e) {


      if($('.template-product .form').attr('data-productid') == '9745311531314') {

          var checkedSubscription = $('.template-product .appstle_input_wrapper input[type=radio]:checked');

          if(checkedSubscription.attr('value') == '6422200626') {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
              console.log('Subscribe & Save');
              $.ajax({
                type: 'POST',
                url: `/cart/add.js?selling_plan=6422266162`,
                data: {
                  quantity: 1,
                  id: 49713747329330,
                  selling_plan: 6422266162,
                },
                dataType: 'json',
                success: function() {
                  console.log('Product added to cart!');
                },
                error: function(XMLHttpRequest, textStatus) {
                  console.log({ XMLHttpRequest })
                  console.log('Error adding product to cart: ' + textStatus);
                }
              });

            setTimeout(() => {
              if (window.SLIDECART_STATE().settings.enabled) {
                window.SLIDECART_UPDATE();
                window.SLIDECART_OPEN();
              }else{
                window.location.href = '/cart';
             }  
            }, "1000");
            
          } else if(checkedSubscription.attr('value') == '') {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
              $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: 1,
                    id: 49713747329330
                  },
                  dataType: 'json',
                  success: function() {
                    console.log('Product added to cart!');
                  },
                  error: function(XMLHttpRequest, textStatus) {
                    console.log('Error adding product to cart: ' + textStatus);
                  }
                });
  
              setTimeout(() => {
                  if (window.SLIDECART_STATE().settings.enabled) {
                    window.SLIDECART_UPDATE();
                    window.SLIDECART_OPEN();
                  }else{
                    window.location.href = '/cart';
                 }
              }, "1000");
            
          }
        
      }
      

      if($('.template-product .form').attr('data-productid') == '9744293101874') {

          var checkedSubscription = $('.template-product .appstle_input_wrapper input[type=radio]:checked');

          if(checkedSubscription.attr('value') == '6398247218') {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
              console.log('Subscribe & Save');
              $.ajax({
                type: 'POST',
                url: `/cart/add.js?selling_plan=3578069298`,
                data: {
                  quantity: 1,
                  id: 44702951932210,
                  selling_plan: 3578069298,
                },
                dataType: 'json',
                success: function() {
                  console.log('Product added to cart!');
                },
                error: function(XMLHttpRequest, textStatus) {
                  console.log({ XMLHttpRequest })
                  console.log('Error adding product to cart: ' + textStatus);
                }
              });

            setTimeout(() => {
              if (window.SLIDECART_STATE().settings.enabled) {
                window.SLIDECART_UPDATE();
                window.SLIDECART_OPEN();
              }else{
                window.location.href = '/cart';
             }  
            }, "1000");
            
          } else if(checkedSubscription.attr('value') == '6380093746') {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
              $.ajax({
                type: 'POST',
                url: `/cart/add.js?selling_plan=6309478706`,
                data: {
                  quantity: 1,
                  id: 49482607919410,
                  selling_plan: 6309478706,
                },
                dataType: 'json',
                success: function() {
                  console.log('Product added to cart!');
                },
                error: function(XMLHttpRequest, textStatus) {
                  console.log({ XMLHttpRequest })
                  console.log('Error adding product to cart: ' + textStatus);
                }
              });
  
              setTimeout(() => {
                  if (window.SLIDECART_STATE().settings.enabled) {
                    window.SLIDECART_UPDATE();
                    window.SLIDECART_OPEN();
                  }else{
                    window.location.href = '/cart';
                 }
              }, "1000");
            
          }
        
        
      }

      if($('.template-product .form').attr('data-productid') == '9683566133554') {

          var checkedSubscription = $('.template-product .appstle_input_wrapper input[type=radio]:checked');

          if(checkedSubscription.attr('value') == '3585671474') {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
              console.log('Subscribe & Save');
              $.ajax({
                type: 'POST',
                url: `/cart/add.js?selling_plan=3578069298`,
                data: {
                  quantity: 1,
                  id: 49476647256370,
                  selling_plan: 3578069298,
                },
                dataType: 'json',
                success: function() {
                  console.log('Product added to cart!');
                },
                error: function(XMLHttpRequest, textStatus) {
                  console.log({ XMLHttpRequest })
                  console.log('Error adding product to cart: ' + textStatus);
                }
              });

            setTimeout(() => {
              if (window.SLIDECART_STATE().settings.enabled) {
                window.SLIDECART_UPDATE();
                window.SLIDECART_OPEN();
              }else{
                window.location.href = '/cart';
             }  
            }, "1000");
            
          } else if(checkedSubscription.attr('value') == '') {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
              $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: 1,
                    id: 49476647256370
                  },
                  dataType: 'json',
                  success: function() {
                    console.log('Product added to cart!');
                  },
                  error: function(XMLHttpRequest, textStatus) {
                    console.log('Error adding product to cart: ' + textStatus);
                  }
                });
  
              setTimeout(() => {
                  if (window.SLIDECART_STATE().settings.enabled) {
                    window.SLIDECART_UPDATE();
                    window.SLIDECART_OPEN();
                  }else{
                    window.location.href = '/cart';
                 }
              }, "1000");
            
          }
        
        
      }

      if($('.template-product .form').attr('data-productid') == '9681763696946') {

          var checkedSubscription = $('.template-product .appstle_input_wrapper input[type=radio]:checked');

          if(checkedSubscription.attr('value') == '3585671474') {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
              console.log('Subscribe & Save');
              $.ajax({
                type: 'POST',
                url: `/cart/add.js?selling_plan=3578069298`,
                data: {
                  quantity: 1,
                  id: 49481774104882,
                  selling_plan: 3578069298,
                },
                dataType: 'json',
                success: function() {
                  console.log('Product added to cart!');
                },
                error: function(XMLHttpRequest, textStatus) {
                  console.log({ XMLHttpRequest })
                  console.log('Error adding product to cart: ' + textStatus);
                }
              });

            setTimeout(() => {
              if (window.SLIDECART_STATE().settings.enabled) {
                window.SLIDECART_UPDATE();
                window.SLIDECART_OPEN();
              }else{
                window.location.href = '/cart';
             }  
            }, "1000");
            
          } else if(checkedSubscription.attr('value') == '') {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
              $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: 1,
                    id: 49481774104882
                  },
                  dataType: 'json',
                  success: function() {
                    console.log('Product added to cart!');
                  },
                  error: function(XMLHttpRequest, textStatus) {
                    console.log('Error adding product to cart: ' + textStatus);
                  }
                });
  
              setTimeout(() => {
                  if (window.SLIDECART_STATE().settings.enabled) {
                    window.SLIDECART_UPDATE();
                    window.SLIDECART_OPEN();
                  }else{
                    window.location.href = '/cart';
                 }
              }, "1000");
            
          }
        
        
      }

      if($('.template-product .form').attr('data-productid') == '9673641099570') {

          var checkedSubscription = $('.template-product .appstle_input_wrapper input[type=radio]:checked');

          if(checkedSubscription.attr('value') == '6296011058') {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
              console.log('Subscribe & Save');
              $.ajax({
                type: 'POST',
                url: `/cart/add.js?selling_plan=6296011058`,
                data: {
                  quantity: 1,
                  id: 49447442645298,
                  selling_plan: 6296011058,
                },
                dataType: 'json',
                success: function() {
                  console.log('Product added to cart!');
                },
                error: function(XMLHttpRequest, textStatus) {
                  console.log({ XMLHttpRequest })
                  console.log('Error adding product to cart: ' + textStatus);
                }
              });

            setTimeout(() => {
              if (window.SLIDECART_STATE().settings.enabled) {
                window.SLIDECART_UPDATE();
                window.SLIDECART_OPEN();
              }else{
                window.location.href = '/cart';
             }  
            }, "1000");
            
          } else if(checkedSubscription.attr('value') == '') {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
              $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: 1,
                    id: 49447442645298
                  },
                  dataType: 'json',
                  success: function() {
                    console.log('Product added to cart!');
                  },
                  error: function(XMLHttpRequest, textStatus) {
                    console.log('Error adding product to cart: ' + textStatus);
                  }
                });
  
              setTimeout(() => {
                  if (window.SLIDECART_STATE().settings.enabled) {
                    window.SLIDECART_UPDATE();
                    window.SLIDECART_OPEN();
                  }else{
                    window.location.href = '/cart';
                 }
              }, "1000");
            
          }
        
        
      }

      if($('.template-product .form').attr('data-productid') == '8187445575986') {

          var checkedSubscription = $('.template-product .appstle_input_wrapper input[type=radio]:checked');

          if(checkedSubscription.attr('value') == '3585671474') {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
              console.log('Subscribe & Save');
              $.ajax({
                type: 'POST',
                url: `/cart/add.js?selling_plan=3578069298`,
                data: {
                  quantity: 1,
                  id: 44702951932210, // previous value: 44702951932210,  // variant id
                  selling_plan: 3578069298, //previous value: 3578069298 // selling plan id
                },
                dataType: 'json',
                success: function() {
                  console.log('Product added to cart!');
                },
                error: function(XMLHttpRequest, textStatus) {
                  console.log({ XMLHttpRequest })
                  console.log('Error adding product to cart: ' + textStatus);
                }
              });

            setTimeout(() => {
              if (window.SLIDECART_STATE().settings.enabled) {
                window.SLIDECART_UPDATE();
                window.SLIDECART_OPEN();
              }else{
                window.location.href = '/cart';
             }  
            }, "1000");
            
          } else if(checkedSubscription.attr('value') == '') {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
              $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: 1,
                    id: 44702951932210  // variant id
                  },
                  dataType: 'json',
                  success: function() {
                    console.log('Product added to cart!');
                  },
                  error: function(XMLHttpRequest, textStatus) {
                    console.log('Error adding product to cart: ' + textStatus);
                  }
                });
  
              setTimeout(() => {
                  if (window.SLIDECART_STATE().settings.enabled) {
                    window.SLIDECART_UPDATE();
                    window.SLIDECART_OPEN();
                  }else{
                    window.location.href = '/cart';
                 }
              }, "1000");
            
          }
        
        
      }

      if($('.template-product .form').attr('data-productid') == '8679223722290') {

          var checkedSubscription = $('.template-product .appstle_input_wrapper input[type=radio]:checked');
          console.log(checkedSubscription);

          if(checkedSubscription.attr('value') == '') {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
              $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: 1,
                    id: 44702951932210  // variant id
                  },
                  dataType: 'json',
                  success: function() {
                    console.log('Product added to cart!');
                  },
                  error: function(XMLHttpRequest, textStatus) {
                    console.log('Error adding product to cart: ' + textStatus);
                  }
                });
  
              setTimeout(() => {
                  if (window.SLIDECART_STATE().settings.enabled) {
                    window.SLIDECART_UPDATE();
                    window.SLIDECART_OPEN();
                  }else{
                    window.location.href = '/cart';
                 }
              }, "1000");
            
          } else if(checkedSubscription.attr('value') == '3585671474') {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
              $.ajax({
                type: 'POST',
                url: '/cart/add.js?selling_plan=3578069298',
                data: {
                  quantity: 1,
                  id: 44702951932210,  // variant id
                  selling_plan: 3578069298, // selling plan id
                },
                dataType: 'json',
                success: function() {
                  console.log('Product added to cart!');
                },
                error: function(XMLHttpRequest, textStatus) {
                  console.log('Error adding product to cart: ' + textStatus);
                }
              });

            setTimeout(() => {
              if (window.SLIDECART_STATE().settings.enabled) {
                window.SLIDECART_UPDATE();
                window.SLIDECART_OPEN();
              }else{
                window.location.href = '/cart';
             }  
            }, "1000");
            
          }
        
        
      }
      
    });



    
    var stickyATC = document.querySelector(".cstm_submit-sticky-wrapper");
    var normalATC = document.querySelector(".cstm_submit_form");

    window.addEventListener('scroll', () => {
       
        if (window.scrollY > window.innerHeight*1.7) {
        
          stickyATC.classList.add("cstm_sticky_active");

        }

        else if (window.scrollY < window.innerHeight*1.7) {

          stickyATC.classList.remove("cstm_sticky_active");
          
        }

        
      });

        document.querySelector(".cstm_submit-sticky").addEventListener('click', (e) => {
          
          e.preventDefault();
          normalATC.click();
            
        });
    

  }

  
});